export const teamData:{
  teamname:string,
  category:string,
  join_code:string
}[] = [
{ teamname:'testC', category:'C',join_code:'111-1111-111'},
{ teamname:'testD', category:'D',join_code:'111-1111-222'},
{ teamname:'testE', category:'E',join_code:'111-1111-333'},
{ teamname:'7', category:'C',join_code:'293-6926-439'},
{ teamname:'2022', category:'C',join_code:'592-4194-555'},
{ teamname:'√-erek', category:'C',join_code:'737-4564-496'},
{ teamname:'A 3 aranyos', category:'C',join_code:'645-8726-983'},
{ teamname:'Agh', category:'C',join_code:'694-6216-555'},
{ teamname:'Ahol a pacek a still', category:'C',join_code:'539-7500-594'},
{ teamname:'alma', category:'C',join_code:'239-3822-982'},
{ teamname:'Almalé', category:'C',join_code:'142-9139-395'},
{ teamname:'Ami.nem.öl.meg.az.megerősít.', category:'C',join_code:'781-4583-540'},
{ teamname:'ÁMS', category:'C',join_code:'865-8846-893'},
{ teamname:'Anitáék', category:'C',join_code:'862-9276-664'},
{ teamname:'Aszimptoták', category:'C',join_code:'837-2867-336'},
{ teamname:'Az EBEk', category:'C',join_code:'178-5909-484'},
{ teamname:'AztisaKatarakta', category:'C',join_code:'462-6328-779'},
{ teamname:'B a köbön', category:'C',join_code:'563-1913-821'},
{ teamname:'Bárány Sushi', category:'C',join_code:'991-1757-650'},
{ teamname:'Bárcsak ki tudnám olvasni', category:'C',join_code:'984-3337-442'},
{ teamname:'BGÁsz', category:'C',join_code:'712-7742-136'},
{ teamname:'Bográcsgulyás', category:'C',join_code:'123-9106-740'},
{ teamname:'Bojler eladó', category:'C',join_code:'974-4373-321'},
{ teamname:'Borsodi Szitu', category:'C',join_code:'106-4199-780'},
{ teamname:'Boszi C1', category:'C',join_code:'955-2303-625'},
{ teamname:'Boszi C2', category:'C',join_code:'471-2524-692'},
{ teamname:'Boszi C3', category:'C',join_code:'526-6711-644'},
{ teamname:'BPI', category:'C',join_code:'450-8154-398'},
{ teamname:'Citromail', category:'C',join_code:'338-6168-687'},
{ teamname:'Csak 100-on', category:'C',join_code:'380-2510-957'},
{ teamname:'Csapatnév', category:'C',join_code:'808-3246-537'},
{ teamname:'Csikóhalak', category:'C',join_code:'223-1870-840'},
{ teamname:'Csillámpóni', category:'C',join_code:'877-7816-633'},
{ teamname:'Csütörtök tagadók', category:'C',join_code:'178-8672-538'},
{ teamname:'D. Elmék', category:'C',join_code:'835-2776-223'},
{ teamname:'DEG', category:'C',join_code:'602-9985-745'},
{ teamname:'Déliek', category:'C',join_code:'376-2612-970'},
{ teamname:'Derékszögek', category:'C',join_code:'855-1178-142'},
{ teamname:'Dodekaéder', category:'C',join_code:'148-2882-654'},
{ teamname:'DRKG_Kisa', category:'C',join_code:'985-5554-608'},
{ teamname:'DRKG_Kisb', category:'C',join_code:'303-8566-477'},
{ teamname:'DRKG_Kisc', category:'C',join_code:'954-7681-565'},
{ teamname:'DRKG_Kisd', category:'C',join_code:'270-3016-694'},
{ teamname:'Dürer kebab', category:'C',join_code:'673-5751-910'},
{ teamname:'DVD', category:'C',join_code:'506-5300-428'},
{ teamname:'DZSMD', category:'C',join_code:'945-6783-424'},
{ teamname:'E-szesek', category:'C',join_code:'524-3307-954'},
{ teamname:'Együtt', category:'C',join_code:'891-7273-661'},
{ teamname:'Embik', category:'C',join_code:'480-9551-310'},
{ teamname:'Endoszimbionta elméletek', category:'C',join_code:'176-5536-112'},
{ teamname:'EszeS', category:'C',join_code:'232-2026-642'},
{ teamname:'Ez a mondat hat szóból áll.', category:'C',join_code:'452-7644-861'},
{ teamname:'Eznemigaz.', category:'C',join_code:'425-3266-607'},
{ teamname:'Fánk', category:'C',join_code:'550-5653-328'},
{ teamname:'Fenomenális Trió', category:'C',join_code:'466-8428-162'},
{ teamname:'fernye', category:'C',join_code:'378-8466-148'},
{ teamname:'GazdÁszok', category:'C',join_code:'577-9350-606'},
{ teamname:'Géniuszok', category:'C',join_code:'344-1886-135'},
{ teamname:'Golden Trio', category:'C',join_code:'252-2230-306'},
{ teamname:'googolplexek', category:'C',join_code:'880-8633-814'},
{ teamname:'Gömbi háromszögek', category:'C',join_code:'218-6512-974'},
{ teamname:'Gummel', category:'C',join_code:'729-7382-928'},
{ teamname:'gyökalatt MATEKOSOK', category:'C',join_code:'831-1443-560'},
{ teamname:'Gyökmínuszegy', category:'C',join_code:'759-2525-207'},
{ teamname:'Ha.nem.szeretsz.hát.én.szeretlek.', category:'C',join_code:'982-9380-214'},
{ teamname:'Hapigyma', category:'C',join_code:'768-4812-797'},
{ teamname:'Három pont', category:'C',join_code:'622-1503-289'},
{ teamname:'Hatvány harcosok', category:'C',join_code:'966-8368-645'},
{ teamname:'Hexa-goal', category:'C',join_code:'966-2101-977'},
{ teamname:'hexaéder', category:'C',join_code:'481-2593-444'},
{ teamname:'HRK', category:'C',join_code:'833-5800-846'},
{ teamname:'Izé', category:'C',join_code:'364-3159-916'},
{ teamname:'Jankáék', category:'C',join_code:'605-5085-617'},
{ teamname:'JCSM', category:'C',join_code:'263-6705-272'},
{ teamname:'just for fun', category:'C',join_code:'554-6618-412'},
{ teamname:'Kakaóbabok', category:'C',join_code:'506-7875-680'},
{ teamname:'Kaméleonok', category:'C',join_code:'392-8245-237'},
{ teamname:'KDA', category:'C',join_code:'113-5327-643'},
{ teamname:'Képzetes rész', category:'C',join_code:'771-9329-689'},
{ teamname:'Kérjük vissza a tanárainkat!', category:'C',join_code:'193-1101-764'},
{ teamname:'Késő van!', category:'C',join_code:'178-7256-319'},
{ teamname:'Két fiú egy lány', category:'C',join_code:'705-6856-207'},
{ teamname:'Két pasi meg egy kicsi', category:'C',join_code:'749-4295-236'},
{ teamname:'Kezdők', category:'C',join_code:'326-9731-352'},
{ teamname:'KGT', category:'C',join_code:'126-5715-715'},
{ teamname:'Kismitugrászok', category:'C',join_code:'259-5810-853'},
{ teamname:'Kockafejek', category:'C',join_code:'655-8452-583'},
{ teamname:'kovászos uborka', category:'C',join_code:'999-3976-651'},
{ teamname:'Krumpli', category:'C',join_code:'376-8929-411'},
{ teamname:'Kvantorok', category:'C',join_code:'636-6633-104'},
{ teamname:'Lajos a király.', category:'C',join_code:'621-3845-311'},
{ teamname:'Le-Chen-ds', category:'C',join_code:'970-8632-446'},
{ teamname:'Lila Medve', category:'C',join_code:'935-5150-522'},
{ teamname:'Lila Pigvinek', category:'C',join_code:'245-3553-707'},
{ teamname:'Liliék', category:'C',join_code:'384-8586-706'},
{ teamname:'LogIQ', category:'C',join_code:'965-1350-244'},
{ teamname:'LRM', category:'C',join_code:'894-4555-287'},
{ teamname:'Lucernák', category:'C',join_code:'718-4327-909'},
{ teamname:'Matekergők', category:'C',join_code:'405-6691-724'},
{ teamname:'Matekmanók', category:'C',join_code:'129-4506-481'},
{ teamname:'MÁV', category:'C',join_code:'269-7086-739'},
{ teamname:'MBM', category:'C',join_code:'616-5043-484'},
{ teamname:'Megpróbáljuk hátha', category:'C',join_code:'104-8151-845'},
{ teamname:'Mindjárt.éjfél.nem.tudjuk.benevezni.őket.ha ilyen.hosszú.nevet.adunk.nekik', category:'C',join_code:'634-5279-847'},
{ teamname:'Mókaegerek', category:'C',join_code:'552-8410-509'},
{ teamname:'nekem minden mindegy', category:'C',join_code:'775-1039-523'},
{ teamname:'Nekemmind1', category:'C',join_code:'632-3259-966'},
{ teamname:'Nem', category:'C',join_code:'957-9612-996'},
{ teamname:'nemírunkvissza', category:'C',join_code:'393-9782-983'},
{ teamname:'nemktudom', category:'C',join_code:'482-7474-799'},
{ teamname:'Neuronok', category:'C',join_code:'575-4791-122'},
{ teamname:'nyerő 4 es', category:'C',join_code:'413-3867-380'},
{ teamname:'oKOSok', category:'C',join_code:'512-3415-341'},
{ teamname:'Oktaéder', category:'C',join_code:'778-4205-176'},
{ teamname:'Orchideák', category:'C',join_code:'669-1013-823'},
{ teamname:'Orsolya és társai', category:'C',join_code:'530-5283-935'},
{ teamname:'Pablo', category:'C',join_code:'522-6162-129'},
{ teamname:'Palya béjjegeji', category:'C',join_code:'338-1278-874'},
{ teamname:'Pedington', category:'C',join_code:'812-1724-849'},
{ teamname:'Pékátu', category:'C',join_code:'456-9667-450'},
{ teamname:'Poverze', category:'C',join_code:'332-5848-212'},
{ teamname:'PVG10', category:'C',join_code:'352-8621-324'},
{ teamname:'q.e.d.', category:'C',join_code:'939-8643-468'},
{ teamname:'Réka csapata', category:'C',join_code:'759-4222-349'},
{ teamname:'Rókabéka.vagy.békaróka?', category:'C',join_code:'582-3458-863'},
{ teamname:'Rózsaszínelefántok', category:'C',join_code:'561-8418-284'},
{ teamname:'Sárkányfűárusok', category:'C',join_code:'476-3334-400'},
{ teamname:'Saskabaré', category:'C',join_code:'399-8926-768'},
{ teamname:'Schankalawaschreinspringswürmchen', category:'C',join_code:'200-1619-656'},
{ teamname:'Sussy Gussy', category:'C',join_code:'621-9062-956'},
{ teamname:'Számítók', category:'C',join_code:'181-2666-824'},
{ teamname:'Számolásunk jogai', category:'C',join_code:'626-7537-868'},
{ teamname:'Szep-Van-Ber', category:'C',join_code:'349-2362-756'},
{ teamname:'Szorgalom', category:'C',join_code:'406-4683-257'},
{ teamname:'SZRG 910 A', category:'C',join_code:'242-9402-162'},
{ teamname:'SZRG 910 B', category:'C',join_code:'200-7006-468'},
{ teamname:'Tata trio', category:'C',join_code:'401-7073-360'},
{ teamname:'Te tetted e tettetett tettet tettetett tettek tettese, te!', category:'C',join_code:'712-1868-733'},
{ teamname:'Termanó', category:'C',join_code:'912-3947-996'},
{ teamname:'Tetraéder', category:'C',join_code:'839-7918-200'},
{ teamname:'THE', category:'C',join_code:'454-9777-450'},
{ teamname:'Trefort11', category:'C',join_code:'741-8453-884'},
{ teamname:'Trefort12', category:'C',join_code:'857-1620-611'},
{ teamname:'Trefort2', category:'C',join_code:'913-7487-888'},
{ teamname:'Trefort5', category:'C',join_code:'128-5515-612'},
{ teamname:'Trefort7', category:'C',join_code:'386-7083-390'},
{ teamname:'Trefort9', category:'C',join_code:'499-6918-616'},
{ teamname:'Trigebra', category:'C',join_code:'916-3630-561'},
{ teamname:'Unio', category:'C',join_code:'243-8482-414'},
{ teamname:'Virág', category:'C',join_code:'489-8685-654'},
{ teamname:'ViToVi', category:'C',join_code:'878-8257-335'},
{ teamname:'VMD', category:'C',join_code:'786-7779-155'},
{ teamname:'x^2+2xy', category:'C',join_code:'634-7913-321'},
{ teamname:'zia', category:'C',join_code:'675-1019-766'},
{ teamname:'44634', category:'D',join_code:'353-1483-740'},
{ teamname:'√25vös', category:'D',join_code:'434-8242-761'},
{ teamname:'11/E', category:'D',join_code:'342-7291-215'},
{ teamname:'11D2', category:'D',join_code:'384-1079-524'},
{ teamname:'47°36′38″N 93°36′33″W', category:'D',join_code:'539-2128-877'},
{ teamname:'9.A csókos', category:'D',join_code:'377-6261-675'},
{ teamname:'A rinocérosz visszavág', category:'D',join_code:'889-2463-162'},
{ teamname:'aaa', category:'D',join_code:'923-2342-453'},
{ teamname:'abgeplattetes Rotationsellipsoid', category:'D',join_code:'302-5897-790'},
{ teamname:'Alfa', category:'D',join_code:'208-7255-371'},
{ teamname:'Algebratyók', category:'D',join_code:'861-9519-995'},
{ teamname:'Alsóhangon', category:'D',join_code:'840-7667-504'},
{ teamname:'András', category:'D',join_code:'498-1247-599'},
{ teamname:'Anonymusok', category:'D',join_code:'824-9251-504'},
{ teamname:'ATIR', category:'D',join_code:'184-9983-466'},
{ teamname:'B^2, azaz Balázs és Barátai', category:'D',join_code:'786-8032-975'},
{ teamname:'Bahaha nem tudom', category:'D',join_code:'317-4102-931'},
{ teamname:'Bájos csajok', category:'D',join_code:'287-4049-564'},
{ teamname:'BaRaKi', category:'D',join_code:'834-9847-371'},
{ teamname:'Bence és a Többiek', category:'D',join_code:'806-2306-392'},
{ teamname:'Boszi D1', category:'D',join_code:'659-5804-563'},
{ teamname:'Boszi D2', category:'D',join_code:'396-1350-977'},
{ teamname:'Böngészők', category:'D',join_code:'798-5323-156'},
{ teamname:'Burgir', category:'D',join_code:'616-8835-642'},
{ teamname:'Diatria', category:'D',join_code:'475-7312-627'},
{ teamname:'Diffúzió', category:'D',join_code:'896-2823-812'},
{ teamname:'DRKG_NagyA', category:'D',join_code:'180-5894-674'},
{ teamname:'DRKG_NagyB', category:'D',join_code:'146-8795-302'},
{ teamname:'Egységnégyzetek', category:'D',join_code:'868-1348-691'},
{ teamname:'Ekvivalens', category:'D',join_code:'944-6950-204'},
{ teamname:'Este heaven', category:'D',join_code:'423-7247-690'},
{ teamname:'Etalon', category:'D',join_code:'249-1050-727'},
{ teamname:'Ezazállításhamis.', category:'D',join_code:'203-2834-522'},
{ teamname:'Eznemanevünk', category:'D',join_code:'926-3429-757'},
{ teamname:'Felszámoltuk', category:'D',join_code:'337-4082-414'},
{ teamname:'Fogykosok', category:'D',join_code:'263-1611-478'},
{ teamname:'Fulda', category:'D',join_code:'133-8316-661'},
{ teamname:'Fülikék', category:'D',join_code:'999-3948-759'},
{ teamname:'Gömb', category:'D',join_code:'307-2480-285'},
{ teamname:'gyök-erek', category:'D',join_code:'868-3764-181'},
{ teamname:'Gyökkető', category:'D',join_code:'734-5399-619'},
{ teamname:'h(aaaalma)z=n*övény', category:'D',join_code:'587-4292-614'},
{ teamname:'H2OPÓK', category:'D',join_code:'799-1602-235'},
{ teamname:'Hangyászsün tojásai:)', category:'D',join_code:'579-6480-972'},
{ teamname:'Hármasikerprímek', category:'D',join_code:'212-7292-434'},
{ teamname:'Ibal', category:'D',join_code:'199-1965-725'},
{ teamname:'IGEN', category:'D',join_code:'369-1874-812'},
{ teamname:'Ij', category:'D',join_code:'505-2883-268'},
{ teamname:'Ikozaéder', category:'D',join_code:'553-5513-581'},
{ teamname:'Indigó', category:'D',join_code:'559-2815-860'},
{ teamname:'Ineptias', category:'D',join_code:'761-9582-882'},
{ teamname:'Jófejek', category:'D',join_code:'408-8274-234'},
{ teamname:'Kálmán a gnóm', category:'D',join_code:'771-3641-922'},
{ teamname:'Karma', category:'D',join_code:'341-5606-487'},
{ teamname:'Két alma hatalma', category:'D',join_code:'486-6895-488'},
{ teamname:'kiHalász', category:'D',join_code:'911-6575-286'},
{ teamname:'Kisfaktos lányok', category:'D',join_code:'839-7587-964'},
{ teamname:'Kombináció', category:'D',join_code:'202-2939-413'},
{ teamname:'Komolyak', category:'D',join_code:'852-4752-607'},
{ teamname:'Konjukció', category:'D',join_code:'707-4960-849'},
{ teamname:'Kő', category:'D',join_code:'507-2393-151'},
{ teamname:'Köbgyök Három', category:'D',join_code:'289-8560-255'},
{ teamname:'Kör ül belül', category:'D',join_code:'363-8869-620'},
{ teamname:'Lányok a köbön', category:'D',join_code:'602-2976-824'},
{ teamname:'Logikus', category:'D',join_code:'313-1862-842'},
{ teamname:'Lyanyok', category:'D',join_code:'228-5790-824'},
{ teamname:'MAT/FAK/1-2', category:'D',join_code:'199-5200-591'},
{ teamname:'Matek tenger-kalózai', category:'D',join_code:'384-8585-305'},
{ teamname:'Matekosokk', category:'D',join_code:'888-8518-274'},
{ teamname:'Matemacik', category:'D',join_code:'188-4574-471'},
{ teamname:'MATOVI^3', category:'D',join_code:'531-1702-863'},
{ teamname:'Matökfőzelék', category:'D',join_code:'371-9253-638'},
{ teamname:'megnemkérdezettek+Kata', category:'D',join_code:'547-4387-108'},
{ teamname:'Mesterek', category:'D',join_code:'217-6565-814'},
{ teamname:'Mikó&Refi bentlakás', category:'D',join_code:'477-9035-142'},
{ teamname:'Mind2', category:'D',join_code:'101-3519-698'},
{ teamname:'minimanók', category:'D',join_code:'354-7984-535'},
{ teamname:'Na, Csak MI', category:'D',join_code:'956-3608-359'},
{ teamname:'Nem más mint...', category:'D',join_code:'939-9003-900'},
{ teamname:'Nem mindegy??', category:'D',join_code:'103-7401-484'},
{ teamname:'Nem tudom', category:'D',join_code:'710-4559-554'},
{ teamname:'Nem tudom mi legyen', category:'D',join_code:'468-5080-842'},
{ teamname:'Neumanosokk', category:'D',join_code:'921-5032-604'},
{ teamname:'Okos Mókusok', category:'D',join_code:'594-9446-382'},
{ teamname:'Ötödikgyök Kettő', category:'D',join_code:'376-4230-994'},
{ teamname:'Papírhajócskák', category:'D',join_code:'561-7697-877'},
{ teamname:'PBN', category:'D',join_code:'132-2833-554'},
{ teamname:'picifiam', category:'D',join_code:'157-5363-413'},
{ teamname:'Pigeons', category:'D',join_code:'544-4003-951'},
{ teamname:'Pindúr Pandúrok', category:'D',join_code:'783-3654-686'},
{ teamname:'Piramis', category:'D',join_code:'894-5588-197'},
{ teamname:'Racionális fésű', category:'D',join_code:'803-2829-139'},
{ teamname:'red flag', category:'D',join_code:'877-6938-653'},
{ teamname:'sin-telenek', category:'D',join_code:'504-2332-609'},
{ teamname:'SIU', category:'D',join_code:'933-7512-501'},
{ teamname:'sólisztgyurma', category:'D',join_code:'987-5336-721'},
{ teamname:'Suli O clock', category:'D',join_code:'892-8773-496'},
{ teamname:'Sürgék', category:'D',join_code:'736-4238-264'},
{ teamname:'Számszobr-Ászok', category:'D',join_code:'767-9555-960'},
{ teamname:'SzJN', category:'D',join_code:'393-1832-827'},
{ teamname:'SZRG 1112 A', category:'D',join_code:'561-7249-865'},
{ teamname:'TBE', category:'D',join_code:'166-3384-300'},
{ teamname:'Team Princess Power', category:'D',join_code:'868-9183-537'},
{ teamname:'Teljes négyzet', category:'D',join_code:'315-5358-726'},
{ teamname:'Trefort10', category:'D',join_code:'331-1171-895'},
{ teamname:'Trefort13', category:'D',join_code:'789-9962-637'},
{ teamname:'Trefort3', category:'D',join_code:'134-2781-568'},
{ teamname:'Trefort4', category:'D',join_code:'687-9924-315'},
{ teamname:'Trefort6', category:'D',join_code:'791-2798-800'},
{ teamname:'Trefort8', category:'D',join_code:'988-3875-521'},
{ teamname:'Triumvirátus', category:'D',join_code:'698-5097-698'},
{ teamname:'Úgyis nyerni fogunk', category:'D',join_code:'891-9556-592'},
{ teamname:'Valami frappáns', category:'D',join_code:'178-9669-293'},
{ teamname:'Van két ügyes kezünk, van két erős lábunk, és van Gogh', category:'D',join_code:'237-2521-565'},
{ teamname:'Varga Elit', category:'D',join_code:'763-7429-548'},
{ teamname:'Varga-BHG', category:'D',join_code:'966-1651-427'},
{ teamname:'Variáció', category:'D',join_code:'226-3219-787'},
{ teamname:'XY', category:'D',join_code:'386-9142-515'},
{ teamname:'xyz', category:'D',join_code:'766-6803-882'},
{ teamname:'Zsenikék', category:'D',join_code:'692-6627-834'},
{ teamname:'1', category:'E',join_code:'678-1712-374'},
{ teamname:'!véntapasc', category:'E',join_code:'804-4055-412'},
{ teamname:'[INSERT NAME]', category:'E',join_code:'279-4402-520'},
{ teamname:'<3', category:'E',join_code:'786-1303-656'},
{ teamname:'2+2=5', category:'E',join_code:'903-2994-791'},
{ teamname:'3 generáció', category:'E',join_code:'531-9175-263'},
{ teamname:'3Gizi', category:'E',join_code:'948-2698-178'},
{ teamname:'A rémálom visszatér', category:'E',join_code:'644-4432-679'},
{ teamname:'Aliquantulus sumus snobs', category:'E',join_code:'173-1397-493'},
{ teamname:'Asok', category:'E',join_code:'621-1461-218'},
{ teamname:'Autotróf kemoszintetizálók', category:'E',join_code:'613-5449-535'},
{ teamname:'Bb', category:'E',join_code:'333-1464-607'},
{ teamname:'BMI', category:'E',join_code:'823-9790-370'},
{ teamname:'BPG zseni csapat', category:'E',join_code:'650-9181-774'},
{ teamname:'Bulcsú fanclubb', category:'E',join_code:'481-4638-119'},
{ teamname:'Cirmoscicák', category:'E',join_code:'377-3805-249'},
{ teamname:'Dönts érzelmi alapon', category:'E',join_code:'334-8314-611'},
{ teamname:'en nem tudom.', category:'E',join_code:'456-8285-579'},
{ teamname:'Ez a név már foglalt', category:'E',join_code:'559-4764-474'},
{ teamname:'Fogalmam sincs', category:'E',join_code:'913-1659-992'},
{ teamname:'Három kiskacsa', category:'E',join_code:'481-2667-413'},
{ teamname:'ijKLMno', category:'E',join_code:'205-7665-579'},
{ teamname:'irjbebarmit', category:'E',join_code:'407-8556-924'},
{ teamname:'JelenlegMégNemMeghatározottKarakterekSorozata', category:'E',join_code:'439-3920-113'},
{ teamname:'Két pasi meg egy Bogi', category:'E',join_code:'896-7036-845'},
{ teamname:'KJG drill', category:'E',join_code:'182-1625-818'},
{ teamname:'KMN', category:'E',join_code:'537-1171-142'},
{ teamname:'Koch-hópelyhek', category:'E',join_code:'732-8600-378'},
{ teamname:'Konstrukciós hibák', category:'E',join_code:'640-2799-883'},
{ teamname:'Kötél', category:'E',join_code:'973-2573-995'},
{ teamname:'kürtöskalács', category:'E',join_code:'846-7290-770'},
{ teamname:'LiuFelJim', category:'E',join_code:'843-7837-908'},
{ teamname:'Macskétások', category:'E',join_code:'915-8035-958'},
{ teamname:'MATT', category:'E',join_code:'593-4707-830'},
{ teamname:'Mi', category:'E',join_code:'152-5209-284'},
{ teamname:'Natürlich', category:'E',join_code:'239-3741-465'},
{ teamname:'nekem mindegy', category:'E',join_code:'355-9587-693'},
{ teamname:'Nem is jó a zsiráfnak', category:'E',join_code:'742-9283-578'},
{ teamname:'Nem tudtam, hogy kell csapatnév', category:'E',join_code:'800-7063-237'},
{ teamname:'nemnem', category:'E',join_code:'399-8071-629'},
{ teamname:'Nincs ötletünk', category:'E',join_code:'368-9030-640'},
{ teamname:'Nincs2022', category:'E',join_code:'720-3060-616'},
{ teamname:'OLÉO DIM-DIM-DIM OLÉO DIM-DIM', category:'E',join_code:'881-1684-475'},
{ teamname:'Pápaiak a köbön', category:'E',join_code:'924-3140-450'},
{ teamname:'Páros permutációk', category:'E',join_code:'872-7303-690'},
{ teamname:'Pupcsőki Tönyőzsrő', category:'E',join_code:'372-4494-790'},
{ teamname:'Sokvári Olivér szeretői', category:'E',join_code:'340-1325-794'},
{ teamname:'Szija ábel', category:'E',join_code:'672-6293-853'},
{ teamname:'Team Grogu', category:'E',join_code:'629-2029-770'},
{ teamname:'tOngUsztÁnI tUdÓsOk', category:'E',join_code:'785-5440-775'},
{ teamname:'Trefort1', category:'E',join_code:'346-2534-879'},
{ teamname:'TRI-GONOMETRIA', category:'E',join_code:'579-3843-886'},
{ teamname:'Végtelen számrendszerek', category:'E',join_code:'588-6665-142'},
{ teamname:'Vi-La-La', category:'E',join_code:'310-9304-139'},
{ teamname:'Vidéki parasztok', category:'E',join_code:'735-1894-839'},
{ teamname:'Z', category:'E',join_code:'580-6528-113'},
]